import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Form,
  Table,
  Input,
  Button,
  InputGroup,
  Label,
  CardFooter,
  ListGroup,
  ListGroupItem,
} from "reactstrap";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { get_file } from "connection/api";

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { Spanish } from "flatpickr/dist/l10n/es";

// Actions
import { consignmentList, consignmentFilter } from "store/payments/actions";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Pagination from "components/Common/Pagination";
import Loader from "components/Common/Loader";
import Pagination2 from "components/Common/Pagination2";

const ConsignmentList = (props) => {
  const URL = process.env.REACT_APP_URL;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(consignmentFilter(`?search=&created_date=`));
  }, []);

  const [search, setSearch] = useState("");
  const [createdDateRange, setCreatedDateRange] = useState("");
  const [bank, setBank] = useState("");

  const onChange1 = (createdDateRange) => {
    setCreatedDateRange(createdDateRange);
  };

  const onChange2 = (e) => {
    setSearch(e.target.value);
  };

  const onChange3 = (e) => {
    setBank(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const date_1 = createdDateRange[0]
      ? createdDateRange[0].toISOString().slice(0, 10)
      : "";
    const date_2 = createdDateRange[1]
      ? createdDateRange[1].toISOString().slice(0, 10)
      : "";
    let url = `?search=${search}&created_date_after=${date_1}&created_date_before=${date_2}&bank=${bank}`;
    dispatch(consignmentFilter(url));
  };

  const onClick = async () => {
    const date_1 = createdDateRange[0]
      ? createdDateRange[0].toISOString().slice(0, 10)
      : "";
    const date_2 = createdDateRange[1]
      ? createdDateRange[1].toISOString().slice(0, 10)
      : "";
    const excel_url = `${URL}report/consignaciones_excel/?client=${search}&created_date_after=${date_1}&created_date_before=${date_2}&bank=${bank}`;
    try {
      const response = await get_file(excel_url);
      const blob = new Blob([response.data], {
        type: "application/vnd.ms-excel",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Consignaciones_${date_1}_${date_2}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      console.error("Error al descargar el archivo", error);
    }
  };

  const resetFilter = () => {
    setSearch("");
    setCreatedDateRange("");
    setBank("");
    dispatch(consignmentList());
  };

  const params = {
    count: props.consignments.count,
    next: props.consignments.next,
    previous: props.consignments.previous,
    results: props.consignments.results,
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Consignaciones </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Consignaciones"} />
          {props.loading ? (
            <Loader />
          ) : (
            <div>
              <Card>
                <CardBody>
                  <Form onSubmit={onSubmit}>
                    <Row className="justify-content-md-start">
                      <Col lg={2}>
                        <p className="mb-1 font-size-13">Fecha de ingreso:</p>
                        <InputGroup>
                          <Flatpickr
                            className="form-control"
                            placeholder="dd/mm/aaaa"
                            value={createdDateRange}
                            onChange={onChange1}
                            options={{
                              mode: "range",
                              dateFormat: "d/m/Y",
                              locale: Spanish,
                            }}
                          />
                        </InputGroup>
                      </Col>
                      <Col lg={2}>
                        <p className="mb-1 font-size-13">Banco:</p>
                        <Input
                          type="select"
                          className="form-select"
                          name="bank"
                          value={bank}
                          onChange={onChange3}
                        >
                          <option value="" defaultValue>
                            Todos
                          </option>
                          <option value="banco_1">Banco de Bogotá</option>
                          <option value="banco_2">Bancolombia</option>
                        </Input>
                      </Col>
                      <Col lg={2} className="search-box mt-4">
                        <InputGroup>
                          <Input
                            type="text"
                            className="form-control"
                            name="search"
                            placeholder="Cliente..."
                            value={search}
                            onChange={onChange2}
                          />
                          <i className="bx bx-search-alt search-icon" />
                        </InputGroup>
                      </Col>
                      <Col lg={4} className="mt-4">
                        <Button color="primary" type="submit">
                          Aplicar
                        </Button>
                        {search !== "" ||
                        createdDateRange !== "" ||
                        bank !== "" ? (
                          <Button
                            className="ms-2"
                            color="secondary"
                            onClick={resetFilter}
                          >
                            Borrar
                          </Button>
                        ) : null}
                        <Button
                          className="ms-2"
                          color="success"
                          type="button"
                          onClick={onClick}
                        >
                          Exportar
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
              <Card>
                {params.count > 0 ? (
                  <CardBody className="ps-5 pe-5">
                    {/* <h2 className="mb-3 ps-5 font-size-20">Lista de vehículos</h2> */}
                    <div className="table-responsive">
                      <Table
                        className="table table-borderless table-striped align-middle table-centered table-nowrap mb-3"
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <thead className="table-light">
                          <tr>
                            <th className="w-auto">Código</th>
                            <th>Nombre Cliente</th>
                            <th>Medio de pago</th>
                            <th>Banco</th>
                            <th>Valor</th>
                            <th>Fecha</th>
                            <th>Acción</th>
                          </tr>
                        </thead>
                        <tbody>
                          {params.results.map((abono, idx) => (
                            <tr key={idx}>
                              <th scope="row">{abono.client}</th>
                              <td>{abono.full_name}</td>
                              <td>{abono.payment_method}</td>
                              <td>{abono.bank}</td>
                              <td>$ {abono.value.toLocaleString("es-CO")}</td>
                              <td>{abono.created_date}</td>
                              <td>
                                <Link
                                  to={`/consignments/update/${abono.id}`}
                                  style={{ color: "red" }}
                                >
                                  <span className="bx bx-trash fa-lg align-middle"></span>
                                </Link>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                    <Pagination2
                      count={params.count}
                      next={params.next}
                      previous={params.previous}
                      limit={8}
                      baseUrl="consignments/"
                      filterFunction={consignmentFilter}
                    />
                  </CardBody>
                ) : (
                  <CardBody>
                    <h4 className="card-title">No se encontraron resultados</h4>
                  </CardBody>
                )}
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, consignments } = state.Payment;
  return { error, loading, consignments };
};

export default withRouter(connect(mapStateToProps)(ConsignmentList));
